import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

export function loadRaven(vue) {
  if (window) {
    window.GIT_HASH = '%%%%GIT_HASH%%%%'; // Will be replaced by build script
  }

  if (process.env.NODE_ENV === 'production') {
    Raven.config('https://503edebe3b4a4d5691028e3bad0a3eb7@sentry.husleie.no/4').addPlugin(RavenVue, vue).install();
    if ('GIT_HASH' in window && window.GIT_HASH.substr(0, 1) !== '%') {
      Raven.setTagsContext({ git_hash: window.GIT_HASH });
    }
  }
}
